<template>
    <el-collapse style="width: 100%;padding: 10px" v-model="activeNames"  @change="handleChange" class="collapse hiddenScrollbar">
        <el-empty style="height: inherit;" v-if="dataList.length === 0" description="暂无数据"></el-empty>
        <el-collapse-item v-else v-for="(item,index) in dataList"  key="index" :name="index + ''">
            <template slot="title">
                <div class="TopName">
                    <span class="pg">{{ item.resourceName }}</span>
                    <span class="sp">{{ item.productName }}</span>
                </div>
            </template>
            <div class="content">
                <div class="inst" >
                    <p class="bg">费用说明：</p>
                    <p>{{ item.cityTax }} {{ item.vatTax }} {{ item.breakFast }}</p>
                    <p v-if="item.freeFacilitiesAndServices.length > 0" class="bl">可免费提供的设施及服务为：</p>
                    <p v-for="(freeFacilitiesAndServices ,freeIndex) in item.freeFacilitiesAndServices" :key="freeIndex">{{ freeFacilitiesAndServices }}</p>
                    <p v-if="item.paidFacilitiesAndServices.length > 0" class="bl">可有偿提供的设施及服务为：</p>
                    <p v-for="(paidFacilitiesAndServices,paidIndex) in item.paidFacilitiesAndServices" :key="paidIndex">{{ paidFacilitiesAndServices }}</p>
                </div>
                <div class="inst" v-if="item.withdrawalAndModificationMethods.length > 0 ">
                    <p class="bg">退改方法</p>
                    <p v-for="(cancel,cancelIndex) in item.withdrawalAndModificationMethods" :key="cancelIndex">{{ cancel }}</p>
                </div>
                <div class="inst">
                    <p class="bl" v-if="item.invoiceDescription">发票说明：{{ item.invoiceDescription }}</p>
                    <p class="bl" v-if="item.otherInstructions">其他须知：{{ item.otherInstructions }}</p>
                    <p class="mp" v-if="item.safetyInstructions">安全须知:{{ item.safetyInstructions }}</p>
                </div>
            </div>
        </el-collapse-item>
    </el-collapse>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import Order from "@/components/Api/order";

export default {
        name: '',
        components: {},
        // 定义属性
        data() {
                return {
                        activeNames: 0,
                        dataList: [],
                        height: 0
                }
        },
        // 计算属性，会监听依赖属性值随之变化
        computed: {},
        // 监控data中的数据变化
        watch: {},
        // 方法集合
        methods: {
                handleChange() {
                },
                inventoryPolicyDisplay(data) {
                        document.getElementsByClassName('collapse')[0].style.height = 0
                        document.getElementsByClassName('collapse')[0].style.height = this.$parent.$el.getElementsByClassName('el-dialog')[0].clientHeight - 20 + 'px'
                        new Order("order").inventoryPolicyDisplay(data).then(res => {
                                if (res.status === 200) {
                                        this.dataList = res.data
                                        console.log("dataList", this.dataList)
                                }
                        })
                }
        },
        // 生命周期 - 创建完成（可以访问当前this实例）
        created() {

        },
        // 生命周期 - 挂载完成（可以访问DOM元素）
        mounted() {
        },
        beforeCreate() {
        }, // 生命周期 - 创建之前
        beforeMount() {
        }, // 生命周期 - 挂载之前
        beforeUpdate() {
        }, // 生命周期 - 更新之前
        updated() {
        }, // 生命周期 - 更新之后
        beforeDestroy() {
        }, // 生命周期 - 销毁之前
        destroyed() {
        }, // 生命周期 - 销毁完成
        activated() {
        }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style scoped lang="scss">
.el-collapse-item__header {
  height: 0.8rem;
}
.LboxP {
  height: var(--height);
  overflow-y: scroll;
  width: 100%;
  padding-right: 15px;
  padding-top: 10px;

  &:hover {
    cursor: pointer;
  }

  .topMain {
    padding: 5px;

    &:hover {
      background-color: aliceblue;
    }
  }
}

.pg {
  color: #101010;
  margin-top: 16px;
  font-size: 0.16rem;
  font-weight: bold;
}

.sp {
  color: #02a0c6;
  //margin-left: 8px;
  font-size: 0.14rem;
}

.hp {
  color: #686868;
  font-size: 0.14rem;
}

.ml {
  color: #000000;
  border-bottom: 1px solid #f2f2f2;
  padding-bottom: 0.14rem;
}

.bl {
  font-weight: bold;
  color: #101010;
}

.bg {
  font-size: 0.14rem;
  color: #296776;
  font-weight: bold;
  margin-bottom: 14px;
}

.mp {
  font-weight: bold;
  color: #101010;
  margin-top: 35px;
  padding-bottom: 25px;
}

.smp {
  padding-bottom: 25px;
}

p {
  margin-left: 5px;
  color: #101010;
  margin-right: 10px;
}

.topMain {
  width: 3.7rem;
}

.inst {
  margin-top: 20px;
  padding-left: 5px;

  p {
    margin-bottom: 10px;
    font-size: 0.12rem;
  }
}


.TopName {
  width: 100%;
  display: flex;
  flex-direction: column;
  line-height: 1.5;
}
.collapse {
  overflow-y: scroll;
  position: relative;
  top: 5px;
  /deep/ .el-collapse-item__header {
    height: 60px;
  }
  .content {
    background: aliceblue;
    padding: 5px;
    box-shadow: rgba(6, 24, 44, 0.4) 0px 0px 0px 2px, rgba(6, 24, 44, 0.65) 0px 4px 6px -1px, rgba(255, 255, 255, 0.08) 0px 1px 0px inset;
  }
}
</style>
